import { render, staticRenderFns } from "./popoverText.vue?vue&type=template&id=759bc15e&"
import script from "./popoverText.vue?vue&type=script&lang=js&"
export * from "./popoverText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports